//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
let d=[[[0,"Capacity",1,0],[0,"ProcessTime",1,0],[0,"StationLocation",1,"Point",0],[0,"StationName",1,0],[0,"StationType",1,0]],[[["nDescription"],"GetDescription",{R_:{description:""}},0,0],[["description"],"SetDescription",{},1,0],[["secNode"],"SetSECNode",{},1,0]],[]];
SPLM.LineDesigner.ConveyorStationFeatureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.ConveyorStationFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.LineDesigner.ConveyorStationFeatureBuilder.Type = Object.freeze({
    "Load" : "Load", "Unload" : "Unload", "ProcessRun" : "ProcessRun", "ProcessStop" : "ProcessStop", "Idle" : "Idle", "Decision" : "Decision", "Marriage" : "Marriage", "Disassembly" : "Disassembly", "Assembly" : "Assembly", "Stop" : "Stop", "LimitSwitch" : "LimitSwitch", "ProximitySwitch" : "ProximitySwitch", "Reader" : "Reader", "Pusher" : "Pusher"});

export default SPLM;